// // ThermalInvoice.js
// import React, { useContext, useRef } from "react";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import styles from "./ThermalInvoice.module.css";
// import AuthContext from "../../../store/auth-context";
// import ActiveStoreContext from "../../../store/ActiveStoreContext";

// const ThermalInvoice = ( props ) => {
//     const { invoiceDataMaster } = props
//     const printRef = useRef();
//     const authCtx = useContext(AuthContext)
//     const asCtx = useContext(ActiveStoreContext);
//     const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();

//     console.log(invoiceDataMaster)

//     const invoiceData = {
//         sessionIdentifier: "001721807041000002e3170e02bb175648299620250829",
//         discountType: "percentage",
//         dueDate: "2025-08-29",
//         invoiceDate: "2025-08-29",
//         invoiceNumber: "INV-2025-0830-001",
//         clientName: "Annu Sharma",
//         clientPhone: "+91 9876543210",
//         clientEmail: "annu@example.com",
//         items: [
//             { name: "Hair Cut", qty: 1, price: 300 },
//             { name: "Hair Color", qty: 1, price: 1500 },
//             { name: "Face Cleanup", qty: 1, price: 700 },
//         ],
//         discount: 10,
//         taxRate: 18,
//         paidAmount: 2000,
//     };

//     const subTotal = invoiceData?.items?.reduce(
//         (acc, item) => acc + item.qty * item.price,
//         0
//     );

//     const paidTotal = invoiceDataMaster?.collectionData?.reduce(
//         (acc, item) => acc + item?.amount,
//         0
//     );
//     const discountAmount = (subTotal * invoiceData.discount) / 100;
//     const taxedAmount = ((subTotal - discountAmount) * invoiceData.taxRate) / 100;
//     const totalAmount = subTotal - discountAmount + taxedAmount;

//     const handleDownload = async () => {
//         const input = printRef.current;
//         const canvas = await html2canvas(input, { scale: 2 });
//         const imgData = canvas.toDataURL("image/png");

//         const pdf = new jsPDF({
//             orientation: "portrait",
//             unit: "mm",
//             format: [80, canvas.height * 0.2645], // 80mm thermal width
//         });

//         pdf.addImage(imgData, "PNG", 0, 0, 80, (canvas.height * 80) / canvas.width);
//         pdf.save(`${invoiceData.invoiceNumber}.pdf`);
//     };

//     return (
//         <div className={styles.container}>
//             <div className={styles.invoice} ref={printRef}>
//                 <h2 className={styles.title}>{activeStore?.storeName}</h2>
//                 <div className={styles.storeAddress} >
//                     {activeStore?.storeAddress}
//                 </div>
//                 <p>Invoice #: {invoiceDataMaster?.invoiceNumber}</p>
//                 <p>Date: {invoiceDataMaster?.invoiceDate}</p>
//                 <hr />

//                 <p>
//                     <strong>Client:</strong> {invoiceDataMaster?.clientData?.clientName}
//                     <br />
//                     {invoiceDataMaster?.clientData?.mobile}
//                     <br />
//                     {invoiceDataMaster?.clientData?.clientEmail}
//                 </p>
//                 <hr />

//                 <table className={styles.table}>
//                     <thead>
//                         <tr>
//                             <th>Item</th>
//                             <th>Qty</th>
//                             <th>Price</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {invoiceDataMaster?.productData?.map((item, index) => (
//                             <tr key={index}>
//                                 <td>{item.productTitle}</td>
//                                 <td>{item.qty}</td>
//                                 <td>₹{item?.total}</td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//                 <hr />


//                 <h3>Total: ₹{invoiceDataMaster?.grandTotal}</h3>
//                 <p>
//                     <strong>Paid:</strong> ₹{paidTotal}
//                     <br />
//                     <strong>Due:</strong> ₹{invoiceDataMaster?.remainingAmount}
//                 </p>
//                 <hr />
//                 <p className={styles.footer}>Thank you for visiting!</p>
//             </div>

//             <button className={styles.downloadBtn} onClick={handleDownload}>
//                 Download as PDF
//             </button>
//         </div>
//     );
// };

// export default ThermalInvoice;




// import React, { useContext, useRef, forwardRef } from "react";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { useReactToPrint } from "react-to-print";
// import styles from "./ThermalInvoice.module.css";
// import AuthContext from "../../../store/auth-context";
// import ActiveStoreContext from "../../../store/ActiveStoreContext";

// // ✅ Forward ref so react-to-print can access it
// const InvoiceContent = forwardRef(({ invoiceDataMaster, activeStore, paidTotal }, ref) => (
//   <div className={styles.invoice} ref={ref}>
//     <h2 className={styles.title}>{activeStore?.storeName}</h2>
//     <div className={styles.storeAddress}>{activeStore?.storeAddress}</div>
//     <p>Invoice #: {invoiceDataMaster?.invoiceNumber}</p>
//     <p>Date: {invoiceDataMaster?.invoiceDate}</p>
//     <hr />

//     <p>
//       <strong>Client:</strong> {invoiceDataMaster?.clientData?.clientName}
//       <br />
//       {invoiceDataMaster?.clientData?.mobile}
//       <br />
//       {invoiceDataMaster?.clientData?.clientEmail}
//     </p>
//     <hr />

//     <table className={styles.table}>
//       <thead>
//         <tr>
//           <th>Item</th>
//           <th>Qty</th>
//           <th>Price</th>
//         </tr>
//       </thead>
//       <tbody>
//         {invoiceDataMaster?.productData?.map((item, index) => (
//           <tr key={index}>
//             <td>{item.productTitle}</td>
//             <td>{item.qty}</td>
//             <td>₹{item?.total}</td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//     <hr />

//     <h3>Total: ₹{invoiceDataMaster?.grandTotal}</h3>
//     <p>
//       <strong>Paid:</strong> ₹{paidTotal}
//       <br />
//       <strong>Due:</strong> ₹{invoiceDataMaster?.remainingAmount}
//     </p>
//     <hr />
//     <p className={styles.footer}>Thank you for visiting!</p>
//   </div>
// ));

// const ThermalInvoice = (props) => {
//   const { invoiceDataMaster } = props;
//   const printRef = useRef();
//   const authCtx = useContext(AuthContext);
//   const asCtx = useContext(ActiveStoreContext);

//   const activeStore = (() => {
//     try {
//       return asCtx?.activeStore && asCtx.activeStore.trim() !== ""
//         ? JSON.parse(asCtx.activeStore)
//         : null;
//     } catch {
//       return null;
//     }
//   })();

//   const paidTotal = invoiceDataMaster?.collectionData?.reduce(
//     (acc, item) => acc + item?.amount,
//     0
//   );

//   // --- Download PDF ---
//   const handleDownload = async () => {
//     const input = printRef.current;
//     const canvas = await html2canvas(input, { scale: 2 });
//     const imgData = canvas.toDataURL("image/png");

//     const pdf = new jsPDF({
//       orientation: "portrait",
//       unit: "mm",
//       format: [80, canvas.height * 0.2645], // 80mm width
//     });

//     pdf.addImage(imgData, "PNG", 0, 0, 80, (canvas.height * 80) / canvas.width);
//     pdf.save(`${invoiceDataMaster?.invoiceNumber}.pdf`);
//   };

//   // --- Direct Print ---
//   const handlePrint = useReactToPrint({
//     content: () => printRef.current,
//     documentTitle: invoiceDataMaster?.invoiceNumber,
//     pageStyle: `
//       @page {
//         size: 80mm auto;
//         margin: 0;
//       }
//       body {
//         margin: 0;
//         font-family: 'Courier New', monospace;
//         font-size: 12px;
//         line-height: 1.4;
//       }
//     `,
//   });

//   return (
//     <div className={styles.container}>
//       {/* ✅ Wrap content with forwardRef */}
//       <InvoiceContent
//         ref={printRef}
//         invoiceDataMaster={invoiceDataMaster}
//         activeStore={activeStore}
//         paidTotal={paidTotal}
//       />

//       {/* Buttons */}
//       <div className={styles.actions}>
//         <button className={styles.downloadBtn} onClick={handleDownload}>
//           Download PDF
//         </button>
//         <button className={styles.printBtn} onClick={handlePrint}>
//           Print Invoice
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ThermalInvoice;


import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./ThermalInvoice.module.css";
import AuthContext from "../../../store/auth-context";
import ActiveStoreContext from "../../../store/ActiveStoreContext";
import { urlToBase64 } from "../../../Helper/utility";

const ThermalInvoice = ({ invoiceDataMaster }) => {
  const printRef = useRef();
  const asCtx = useContext(ActiveStoreContext);

  const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();

  const paidTotal = invoiceDataMaster?.collectionData?.reduce(
    (acc, item) => acc + item?.amount,
    0
  );

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>${invoiceDataMaster?.invoiceNumber}</title>
          <style>
            @media print {
              @page {
                size: 80mm auto;
                margin: 0;
              }
              body {
                margin: 0;
                font-family: 'Courier New', monospace;
                font-size: 12px;
                line-height: 1.4;
                width: 80mm;
              }
              table {
                width: 100%;
                border-collapse: collapse;
              }
              th, td {
                padding: 2px;
                text-align: left;
              }
              th:last-child, td:last-child {
                text-align: right;
              }
              hr {
                border: none;
                border-top: 1px dashed #000;
                margin: 6px 0;
              }
              .footer {
                text-align: center;
                margin-top: 10px;
              }
            }
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  const calculateTax = (totalAmount, taxPercent) => {
    if (totalAmount <= 0 || taxPercent < 0) {
      return { taxableValue: 0, totalTax: 0 };
    }

    // taxable value = totalAmount / (1 + taxPercent/100)
    const taxableValue = totalAmount / (1 + taxPercent / 100);

    // tax = totalAmount - taxableValue
    const totalTax = totalAmount - taxableValue;

    return {
      taxableValue: parseFloat(taxableValue.toFixed(2)),
      totalTax: parseFloat(totalTax.toFixed(2))
    };
  }

  const [base64Logo, setBase64Logo] = useState(null);
  const fetchBase64Logo = async () => {
    try {
      const base64 = await urlToBase64(
        activeStore?.invoiceLogo
      );
      setBase64Logo(base64);
    } catch (error) {
      console.error("Error converting image to base64:", error);
    }
  };

  useEffect(() => {
    fetchBase64Logo();
  }, []);


  return (
    <div className={styles.container}>
      <div className={styles.invoice} ref={printRef}>
        <div className={styles.logoWrapper}>
          {base64Logo ? (
            <img
              src={base64Logo}
              alt="Salon Logo"
              className={styles.logo}
              id="logo"
            />
          ) : (
            <p>Loading logo...</p>
          )}
        </div>
        <h2>{activeStore?.storeName}</h2>
        <div className={styles.storeAddress} >{activeStore?.storeAddress}</div>
        {activeStore?.gstNumber &&
          <div className={styles.invoiceDataRow} >
            <p>GST Number :</p>
            <p>{activeStore?.gstNumber}</p>
          </div>
        }
        <div className={styles.invoiceDataRow} >
          <p>Invoice #:</p>
          <p>{invoiceDataMaster?.invoiceNumber}</p>
        </div>
        <div className={styles.invoiceDataRow} >
          <p>Date: </p>
          <p>{invoiceDataMaster?.invoiceDate}</p>
        </div>
        <hr />

        <p>
          <strong>Client:</strong> {invoiceDataMaster?.clientData?.clientName}
          <br />
          {invoiceDataMaster?.clientData?.mobile}
          <br />
          {invoiceDataMaster?.clientData?.clientEmail}
        </p>
        <hr />

        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Qty</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            {invoiceDataMaster?.productData?.map((item, idx) => (
              <tr key={idx}>
                <td>{item.productTitle}</td>
                <td>{item.qty}</td>
                <td>₹{item?.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <hr />
        {activeStore?.gstNumber &&
          <div className={styles.taxableWrapper} >
            <div className={styles.eachTaxRow} >
              <h4>Taxable Value</h4>
              <h4>₹{calculateTax(invoiceDataMaster?.grandTotal, 5)?.taxableValue}</h4>
            </div>
            <div className={styles.eachTaxRow} >
              <h4>Total Tax (5%)</h4>
              <h4>₹{calculateTax(invoiceDataMaster?.grandTotal, 5)?.totalTax}</h4>
            </div>
          </div>
        }
        <div className={styles.totalRowWrapper} >
          <h3>Total: </h3>
          <h3>₹{invoiceDataMaster?.grandTotal}</h3>
        </div>
        <div className={styles.totalRowWrapper} >
          <p>
            <strong>Paid:</strong>
          </p>
          <p>
            ₹{paidTotal}
          </p>
        </div>
        <div className={styles.totalRowWrapper} >
          <p>
            <strong>Due:</strong>
          </p>
          <p>
            ₹{invoiceDataMaster?.remainingAmount}
          </p>
        </div>

        <hr />
        <p className="footer">Thank you for visiting!</p>
      </div>

      <div className={styles.actions}>
        <button onClick={handlePrint}>Print Invoice</button>
      </div>
    </div>
  );
};

export default ThermalInvoice;
